export interface AppLocation {
  pathname: string;
  search: string;
  hash: string;
}

export const isSameAppLocation = (destination: string, current: AppLocation): boolean => {
  const target = new URL(destination, 'http://dms.local');
  return `${target.pathname}${target.search}${target.hash}` === `${current.pathname}${current.search}${current.hash}`;
};
